import React from "react";
import { Link } from "react-router-dom";
import { FaGamepad, FaShoppingCart, FaTools } from "react-icons/fa";
import "../style/HomeSections.css";

const highlights = [
  {
    icon: FaGamepad,
    label: "Disponibile",
    title: "Zombie Crushers",
    description:
      "Un survival arcade gratuito. Lo scarichi dal launcher e confronti le tue run nella classifica.",
    meta: "Gratis / Windows",
    cta: { href: "/games/zombie-crushers", label: "Apri la pagina" }
  },
  {
    icon: FaShoppingCart,
    label: "In vendita",
    title: "WarFront",
    description:
      "Prima dello Store c'\u00e8 una scheda con requisiti, licenza e supporto. Cos\u00ec sai cosa stai comprando.",
    meta: "Premium / Store",
    cta: { href: "/games/warfront", label: "Leggi la scheda" }
  },
  {
    icon: FaTools,
    label: "In sviluppo",
    title: "Ghost Hunter",
    description:
      "Non \u00e8 ancora in vendita. Puoi vedere il teaser e seguire i prossimi playtest su Discord.",
    meta: "Playtest",
    cta: { href: "/games/ghost-hunter", label: "Vedi Ghost Hunter" }
  }
];

export default function HomeHighlights() {
  return (
    <section className="home-highlights">
      <div className="home-section__inner">
        <header className="home-highlights__header">
          <span className="home-eyebrow">Giochi</span>
          <h2>Tre giochi, tre stati diversi</h2>
          <p>
            Non tutto ha lo stesso stato: Zombie Crushers si gioca, WarFront si compra dallo Store,
            Ghost Hunter si segue mentre prende forma.
          </p>
        </header>

        <div className="home-highlights__grid">
          {highlights.map(highlight => {
            const Icon = highlight.icon;
            return (
              <article key={highlight.title} className="home-highlight-card">
                <div className="home-highlight-card__icon">
                  <Icon aria-hidden="true" />
                </div>
                <div className="home-highlight-card__body">
                  <span className="home-highlight-card__label">{highlight.label}</span>
                  <h3>{highlight.title}</h3>
                  <p>{highlight.description}</p>
                  <span className="home-highlight-card__meta">{highlight.meta}</span>
                </div>
                <Link className="home-highlight-card__link" to={highlight.cta.href}>
                  {highlight.cta.label}
                </Link>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
